<script setup>
const model = defineModel() // v-model value (selected name or object)

defineProps({
  options: {
    type: Array,
    required: true
  }
})

const checked = (name) => {
    return name == model.value
}
</script>

<template>

  <div data-kt-buttons="true" class="row justify-content-center align-items-center">
    <div v-for="(item, i) in options" :key="i" class="col-6 d-flex justify-content-center" >
        <label class="btn btn-outline btn-outline btn-outline-default p-7 flex-column align-items-center mb-5" :class="checked(item.name) ? ' border border-primary' : 'btn-outline-default'" >
            <img
                :src="item.img"
                class="h-10 w-14 rounded-full object-cover border"
            />
            <div class="d-flex mt-2"> 
                <div class="form-check form-check-custom form-check-solid form-check-primary me-6">
                    <input class="form-check-input" type="radio" name="paneliste" :checked="checked(item.name)"  v-model="model"  :value="item.name"/>
                </div>
                <span class="text-dark fs-1">{{ item.name }}</span>
            </div>
        </label>
    </div>
  </div>
</template>
